module.exports = __webpack_public_path__ + "img/chat-right-quote-fill.7e306c3a.svg";